import styled, { css } from 'styled-components';
import { TicketCounter } from '../../ticketCounter';
import { whenThemePropEqualsTrue } from '../../../../theme/getters';

export const Content = styled.div``;

const whenIsLast = whenThemePropEqualsTrue('isLast');

const getLastItemStyles = whenIsLast(
  () => css`
    margin-bottom: 0;
    border-bottom: none;
  `
);

export const Counter = styled(TicketCounter)`
  margin-bottom: 18px;

  ${getLastItemStyles}
`;
